import { BASE_URL } from "../../../config/apiConfig";

const FileUploadCard = ({ label, fileUrl, fileName, padding="" }) => {
  const hasFile = fileUrl && fileName;

  return (
    <div className="border rounded p-3 text-sm text-gray-700 bg-white shadow-sm">
      <div className={`flex justify-between items-center ${padding}`}>
        <span>{label}</span>

        {hasFile ? (
          <a
            className={`bg-btn text-white px-4 py-2 rounded text-md ${padding}`}
            href={`${BASE_URL}/${fileUrl}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            View
          </a>
        ) : (
          <span className="text-gray-400 text-sm">No file uploaded</span>
        )}
      </div>
    </div>
  );
};

export default FileUploadCard;
